import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import ServiceRestServices from '../../services/service-rest.service';
import Session from '../../utils/session.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'corporate-customers-only',
	templateUrl: './corporate-customers-only.component.html',
	imports: [
		CommonModule, TranslatePipe, LoaderOverlayComponent, 
		ItemErrorComponent, FormsModule, RouterLink
	]
})
export default class CorporateCustomersOnlyView implements OnInit {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking')
			.then(() => {
				this.onResolve();
			});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.buttonTheme1 = (this.vm.user.origin == 'siffi.com' ? 'c-button--s2' : 'c-button--s1');
		
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.handleInputChange = this.handleInputChange;
	}
	
	handleInputChange() {
		this.vm.error = undefined;
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.success = undefined;
		this.vm.error = undefined;
		this.vm.submitted = true;
		
		if (mainForm.invalid || this.vm.processing) return;
		this.vm.processing = true;
		
		this.serviceRestServices.recommendToEmployerRequest({ email: this.vm.email })
			.then((res) => {
				this.vm.submitted = false;
				this.vm.email = undefined;
				this.vm.success = this.angularFilterHelperService.translate('CorporateCustomersOnly.Success');
				this.vm.processing = false;
			}).catch((err) => {
				try { this.vm.error = err.error[0].message; } catch (e) { }
				this.vm.processing = false;
			});
	}
	
}